import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { useMemo } from 'react';
import { Icon } from '@/components';

interface Props {
  onBulkUpdate: () => any;
  onDuplicate: () => any;
  onBulkDelete: () => any;
  onCreateGroup: () => any;
  disabled?: boolean;
}

export function TasksListActions(props: Props) {
  const { onBulkUpdate, onDuplicate, onBulkDelete, disabled, onCreateGroup } =
    props;

  const { t } = useTranslation();

  const items: ItemType[] = useMemo(() => {
    return [
      {
        key: `tasks_createGroup_action`,
        onClick: onCreateGroup,
        label: t('tasks.groups.createAction'),
        disabled: disabled,
      },
      {
        key: `tasks_bulkUpdate_action`,
        onClick: onBulkUpdate,
        label: t('tasks.bulkUpdate.action'),
        disabled: disabled,
      },
      {
        key: `tasks_duplicate_action`,
        onClick: onDuplicate,
        label: t('tasks.duplicate.action'),
        disabled: disabled,
      },
      {
        key: 'tasks_delete_action',
        onClick: onBulkDelete,
        label: t('tasks.bulkDelete.action'),
        disabled: disabled,
      },
    ];
  }, [onCreateGroup, t, disabled, onBulkUpdate, onDuplicate, onBulkDelete]);

  return (
    <Dropdown
      className="mb-3"
      trigger={['click']}
      overlay={<Menu items={items} />}
    >
      <Button>
        <Space>
          {t('actions')}
          <Icon type="arrow-down" />
        </Space>
      </Button>
    </Dropdown>
  );
}
